import http from "../utils/http-common-nbs";

class QRCodeService {
  post(string) {
    return http.post("generate", string);
  }
}

export default new QRCodeService();